import * as types from './_actionTypes';

// Course Category Actions
export const fetchCourseCategoriesRequest = (params = {}) => ({
  type: types.FETCH_COURSE_CATEGORIES_REQUEST,
  payload: params
});

export const fetchCourseCategoriesSuccess = (categories) => ({
  type: types.FETCH_COURSE_CATEGORIES_SUCCESS,
  payload: categories
});

export const fetchCourseCategoriesFailure = (error) => ({
  type: types.FETCH_COURSE_CATEGORIES_FAILURE,
  payload: error
});

export const createCourseCategoryRequest = (categoryData) => ({
  type: types.CREATE_COURSE_CATEGORY_REQUEST,
  payload: categoryData
});

export const createCourseCategorySuccess = (category) => ({
  type: types.CREATE_COURSE_CATEGORY_SUCCESS,
  payload: category
});

export const createCourseCategoryFailure = (error) => ({
  type: types.CREATE_COURSE_CATEGORY_FAILURE,
  payload: error
});

export const updateCourseCategoryRequest = (categoryId, updateData) => ({
  type: types.UPDATE_COURSE_CATEGORY_REQUEST,
  payload: { categoryId, updateData }
});

export const updateCourseCategorySuccess = (category) => ({
  type: types.UPDATE_COURSE_CATEGORY_SUCCESS,
  payload: category
});

export const updateCourseCategoryFailure = (error) => ({
  type: types.UPDATE_COURSE_CATEGORY_FAILURE,
  payload: error
});

export const deleteCourseCategoryRequest = (categoryId) => ({
  type: types.DELETE_COURSE_CATEGORY_REQUEST,
  payload: categoryId
});

export const deleteCourseCategorySuccess = (categoryId) => ({
  type: types.DELETE_COURSE_CATEGORY_SUCCESS,
  payload: categoryId
});

export const deleteCourseCategoryFailure = (error) => ({
  type: types.DELETE_COURSE_CATEGORY_FAILURE,
  payload: error
});

export const getCourseCategoryByIdRequest = (categoryId) => ({
  type: types.GET_COURSE_CATEGORY_BY_ID_REQUEST,
  payload: categoryId
});

export const getCourseCategoryByIdSuccess = (category) => ({
  type: types.GET_COURSE_CATEGORY_BY_ID_SUCCESS,
  payload: category
});

export const getCourseCategoryByIdFailure = (error) => ({
  type: types.GET_COURSE_CATEGORY_BY_ID_FAILURE,
  payload: error
});

// Course Actions
export const fetchCoursesRequest = (params = {}) => ({
  type: types.FETCH_COURSES_REQUEST,
  payload: params
});

export const fetchCoursesSuccess = (courses) => ({
  type: types.FETCH_COURSES_SUCCESS,
  payload: courses
});

export const fetchCoursesFailure = (error) => ({
  type: types.FETCH_COURSES_FAILURE,
  payload: error
});

export const createCourseRequest = (courseData) => ({
  type: types.CREATE_COURSE_REQUEST,
  payload: courseData
});

export const createCourseSuccess = (course) => ({
  type: types.CREATE_COURSE_SUCCESS,
  payload: course
});

export const createCourseFailure = (error) => ({
  type: types.CREATE_COURSE_FAILURE,
  payload: error
});

export const updateCourseRequest = (courseId, updateData) => ({
  type: types.UPDATE_COURSE_REQUEST,
  payload: { courseId, updateData }
});

export const updateCourseSuccess = (course) => ({
  type: types.UPDATE_COURSE_SUCCESS,
  payload: course
});

export const updateCourseFailure = (error) => ({
  type: types.UPDATE_COURSE_FAILURE,
  payload: error
});

export const deleteCourseRequest = (courseId) => ({
  type: types.DELETE_COURSE_REQUEST,
  payload: courseId
});

export const deleteCourseSuccess = (courseId) => ({
  type: types.DELETE_COURSE_SUCCESS,
  payload: courseId
});

export const deleteCourseFailure = (error) => ({
  type: types.DELETE_COURSE_FAILURE,
  payload: error
});

export const getCourseByIdRequest = (courseId) => ({
  type: types.GET_COURSE_BY_ID_REQUEST,
  payload: courseId
});

export const getCourseByIdSuccess = (course) => ({
  type: types.GET_COURSE_BY_ID_SUCCESS,
  payload: course
});

export const getCourseByIdFailure = (error) => ({
  type: types.GET_COURSE_BY_ID_FAILURE,
  payload: error
});

// SME Assignment Actions
export const assignSMEToCourseRequest = (courseId, smeId) => ({
  type: types.ASSIGN_SME_TO_COURSE_REQUEST,
  payload: { courseId, smeId }
});

export const assignSMEToCourseSuccess = (courseId, smeData) => ({
  type: types.ASSIGN_SME_TO_COURSE_SUCCESS,
  payload: { courseId, smeData }
});

export const assignSMEToCourseFailure = (error, courseId) => ({
  type: types.ASSIGN_SME_TO_COURSE_FAILURE,
  payload: error,
  meta: { courseId }
});

export const unassignSMEFromCourseRequest = (courseId, smeId) => ({
  type: types.UNASSIGN_SME_FROM_COURSE_REQUEST,
  payload: { courseId, smeId }
});

export const unassignSMEFromCourseSuccess = (courseId, smeId) => ({
  type: types.UNASSIGN_SME_FROM_COURSE_SUCCESS,
  payload: { courseId, smeId }
});

export const unassignSMEFromCourseFailure = (error, courseId) => ({
  type: types.UNASSIGN_SME_FROM_COURSE_FAILURE,
  payload: error,
  meta: { courseId }
});

export const getCourseSMEsRequest = (courseId) => ({
  type: types.GET_COURSE_SMES_REQUEST,
  payload: courseId
});

export const getCourseSMEsSuccess = (courseId, smes) => ({
  type: types.GET_COURSE_SMES_SUCCESS,
  payload: { courseId, smes }
});

export const getCourseSMEsFailure = (error) => ({
  type: types.GET_COURSE_SMES_FAILURE,
  payload: error
});

// Mux Video Upload Actions


// UI State Actions
export const clearCourseError = () => ({
  type: types.CLEAR_COURSE_ERROR
});

export const setCourseLoading = (loading) => ({
  type: types.SET_COURSE_LOADING,
  payload: loading
});

export const resetCourseState = () => ({
  type: types.RESET_COURSE_STATE
});

export const setSelectedCategory = (categoryId) => ({
  type: types.SET_SELECTED_CATEGORY,
  payload: categoryId
});